/**
 * ReturnPolicy.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import EditablePage from './EditablePage';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { getTranslatedPage } from '../i18n/pages';

export default function ReturnPolicy() {
  const { language } = useLanguage();
  const tr = getTranslatedPage('return-policy', language);
  return (
    <>
      <SEO 
        title={`${tr?.title || 'Return Policy'} | Cranford Publications`}
        description={tr?.description || 'Learn about our return and refund policy for Celtic music books and CDs from Cranford Publications.'}
        canonical="/return-policy"
        keywords="return policy, refunds, product returns"
      />
      <EditablePage pageId="return-policy" pageTitle={tr?.title || 'Return Policy'} />
    </>
  );
} 